<template>
  <div class="icon" ref="IconaItem">
    <div class="icon-image" ref="iconImage">
      <img :src="absoluteURL(icona.icona.url)"/>
    </div>
    <div class="title" ref="iconTitle">{{ icona.titolo }}</div>
    <div class="description" ref="iconText">{{ icona.testo }}</div>
  </div>
</template>

<script>
  import {TimelineMax} from 'gsap'
  import ScrollMagic from 'scrollmagic'
  import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'

  export default {
    name: 'Icona',
    props: ['icona'],
    data() {
      return {
        controller: new ScrollMagic.Controller(),
      }
    },
    created() {

    },
    mounted() {
      this.animations();
    },
    methods: {
      animations() {
        const {IconaItem} = this.$refs
        const {iconImage} = this.$refs
        const {iconTitle} = this.$refs
        const {iconText} = this.$refs

        const timeline = new TimelineMax({paused: true})
        timeline.from(IconaItem, 1, {opacity: 0, y: 50, ease: Power4.easeOut})
                .from(iconImage, 1, {opacity: 0, y: -20, ease: Power4.easeOut}, '-=0.4')
                .from(iconTitle, .75, {opacity: 0, y: 30, ease: Power4.easeOut}, '-=0.75')
                .from(iconText, .75, {opacity: 0, y: 30, ease: Power4.easeOut}, '-=0.5');

        const scene = new ScrollMagic.Scene({
          triggerElement: IconaItem,
          triggerHook: 0.75,
          offset: 0
        }).on('enter', function (event) {
          timeline.play().timeScale(1);
        }).on('leave', function (event) {
          timeline.reverse().timeScale(1.5)
        }).addTo(this.controller);
      }
      ,
      absoluteURL(relativeURL) {
        return process.env.VUE_APP_HOST_URL + relativeURL;
      }
    }
  }
</script>
